import { render, staticRenderFns } from "./SPeriods.vue?vue&type=template&id=197a5a58"
import script from "./SPeriods.vue?vue&type=script&lang=js"
export * from "./SPeriods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports